import React, { Component } from 'react';
import { Box, Button } from '@mui/material';

class ExtractsList extends Component {
    state = {  }

    render() {
        return (
            <Box>
                {/* {this.state.loading && this.state.url &&
                    <DownloadProgress
                        {...this.state}
                        handleLoading={() => this.setState({ loading: false, url: "", title: "" })}
                    />  
                } */}

                {/* <Grid container spacing={2} >
                    <Grid item xs={12} sm={6} >
                        <DatePicker
                            required
                            label="Du"
                            handleChange={(date)=> this.setState({ start_date: date})}
                            value={this.state.start_date}
                            id="start_date"
                            maxDate={this.state.end_date || new Date()}

                        />
                    </Grid>
                    <Grid item xs={12} sm={6} >
                        <DatePicker
                            required
                            label="Au"
                            handleChange={(date)=> this.setState({ end_date: date})}
                            value={this.state.end_date}
                            id="end_date"
                            maxDate={new Date()}
                            minDate={this.state.start_date || new Date()}
                        />
                    </Grid>
                </Grid> */}
                
                <Box p={3}>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={ () => this.props.openFormDownload("/extract/spendings/sage", "Extract Sage", "MJB_Sage.csv") } 
                        disabled={this.props.downloading}
                    >
                        Extract Sage    
                    </Button>
                    <br />
                    <br />
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={ () => this.props.openFormDownload("/extract/spendings/perfecto", "Extract Perfecto", "MJB_Perfecto.csv") } 
                        disabled={this.props.downloading}
                    >
                        Extract Perfecto    
                    </Button>
                    <br />
                    <br />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => this.props.openFormDownload("/extract/in/out")}
                        disabled={this.props.downloading}
                    >
                        Trésorerie    
                    </Button>
                    <br />
                    <br />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => this.props.openFormDownload("/extract/in/out/analysis")}
                        disabled={this.props.downloading}
                    >
                        Trésorerie Complet
                    </Button>
                    <br />
                    <br />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => this.props.openFormDownload("/extract/MGM", "Extract MGM", "MJB_MGM.csv")}
                        disabled={this.props.downloading}
                    >
                        MGM    
                    </Button>
                    <br />
                    <br />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => this.props.openFormDownload("/extract/MGM/spendings", "Extract MGM Spendings", "MJB_MGM_spendings.csv")}
                        disabled={this.props.downloading}
                    >
                        MGM Dépenses
                    </Button>
                </Box>
                
                {/* <Box p={3}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={ () => this.props.handleDownload("/extract/salary", "MyJouleBox-Salaires.csv") } 
                        disabled={this.state.loading}
                    >
                        Extract Salaire    
                    </Button>
                </Box> */}
            </Box>
        );
    }
}

export default ExtractsList;